import { FC, useCallback } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
} from "@mui/material";

interface ChartSeriesSelectProps {
  series: number;
  onSeriesChange(series: number): void;
}

export const ChartSeriesSelect: FC<ChartSeriesSelectProps> = ({
  series,
  onSeriesChange,
}) => {
  const changeHandler = useCallback(
    (event: SelectChangeEvent<number>) => {
      const val = +(event.target.value ?? 10);

      if (!val || val === series) {
        return;
      }

      onSeriesChange(val);
    },
    [onSeriesChange, series],
  );

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>Series</InputLabel>

      <Select
        value={series}
        label="Series"
        size="small"
        MenuProps={selectMenuProps}
        onChange={changeHandler}
      >
        {options.map((value) => (
          <MenuItem key={value} value={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const options = [10, 15, 20, 25, 30, 35];

const selectMenuProps: SelectProps["MenuProps"] = {
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: 5, horizontal: "left" },
};
